import React from 'react';
import { Button, Box, Text, useDisclosure, Heading, Center, Image } from '@chakra-ui/react';

import useLang from '@/hooks/useLang';

import WithAnimation from '@/components/Common/WithAnimation';
import kawungImg from '@/assets/icons/kawung.svg';

import { BG_LAYER, BUTTON_PADDING_PROPS } from '@/constants/colors';
import { ASSETS_BUTTERFLY } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

import Content from './Content';
import txt from './locales';

function LoveStory({ ...rest }) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const lang = useLang();

  return (
    <>
      <Box pos="relative" mx="auto" width={{ lg: '70%', base: '80%' }} zIndex="3" {...rest}>
        <WithAnimation>
          <Center
            width="100%"
            mx="auto"
            pos="relative"
            borderRadius="16px"
            border="1px solid"
            borderColor="bgSecondary"
            bgColor={BG_LAYER}
            minHeight="40vh"
            padding="24px"
            my="24px"
            mb="150px"
            {...TEXT_PROPS.body}
            textAlign="center"
          >
            <Box
              className="animation__butterfly"
              position="absolute"
              top={{ '3sm': '30px', '2sm': '40px', '1sm': '30px', sm: '0px' }}
              left={{ '3sm': '30px', '2sm': '20px', '1sm': '15px', sm: '0px' }}
              zIndex="3"
            >
              <WithAnimation left delay={500}>
                <Image src={ASSETS_BUTTERFLY} maxW="50px" />
              </WithAnimation>
            </Box>
            <Center flexDir="column">
              <WithAnimation>
                <Heading {...TEXT_PROPS.heading} padding="0 18px">Love Story</Heading>
              </WithAnimation>

              <WithAnimation>
                <Text
                  {...TEXT_PROPS.body}
                  align="center"
                  margin="16px 0"
                  padding="0 28px"
                  dangerouslySetInnerHTML={{ __html: txt.desc[lang] }}
                />
              </WithAnimation>

              <WithAnimation>
                <Button {...BUTTON_PADDING_PROPS} mt="24px" onClick={onOpen}>
                  {txt.textButton[lang]}
                </Button>
              </WithAnimation>
            </Center>
          </Center>
        </WithAnimation>
        <Content onClose={onClose} visible={isOpen} />
      </Box>
      <Box
        width="100%"
        height={{ lg: '150px', '3sm': '150px', '1sm': '220px', sm: '200px' }}
        marginTop={{ lg: '-48px', '3sm': '-48px', '1sm': '-100px', sm: '-40px' }}
        position="relative"
        zIndex="1"
      >
        <Box
          pos="absolute"
          bottom="0"
          width="100%"
          height="80%"
          bgImage="linear-gradient(to top, #FFF7ED, transparent)"
          zIndex="2"
        />
        <Box
          pos="absolute"
          bottom="0"
          left="0"
          width="100%"
          height={{ '3sm': '60%', '2sm': '40%', sm: '30%' }}
          bgImage={kawungImg}
          bgSize="contain"
          bgPos="top center"
          bgRepeat="repeat-x"
          zIndex="4"
        />
      </Box>
    </>
  );
}

export default LoveStory;
